import InvestSchemeDetailCard from './InvestSchemeDetailCard';
import OtherDetailsCard from './OtherDetailsCard';
import TransactionCard from './TransactionCard';
import {
  Row,
  Col,
  P1,
  P2,
  B2,
  B1,
  CheckBox,
  H5,
  Modal,
  DotLoader,
  Button,
  Radio,
  ModalFooterWithConfirmation,
  ReadMore,
} from 'pfm-ui-components';

import { up } from 'styled-breakpoints';
import styled from 'styled-components';
import { pxToRem } from '../../../../styles/utils';
import * as constants from '../../../../constants/investTransactPage';
import { useFormik } from 'formik';
import VerifyOTPModal from '../../../common/VerifyOTPModal';
import { useState } from 'react';
import Accordion from '../../../common/Accordion';
import NomineeDetailsBlock from '../../portfolio/myProfile/NomineeDetailsBlock';
import React from 'react';
import NomineeModal from './NomineeModal';
import { BuyDetailsProps, InvestmentIdDetails, RelationShipCodes } from '../../../../pages/transact/invest';
import * as yup from 'yup';
import { convertArrayOfObjectToObject, getQueryParamSymbol } from '../../../../utils/common';
import {
  convertArrayOfStringsToDropDownOptionsFormat,
  convertToDefaultNomineeDataFormat,
  convertToDefaultNomineeUIFormat,
  convertToNomineesDataFormat,
} from './util';
import { useEffect } from 'react';
import { investmentTimeFrameSelectedMatchesUserRiskProfile, validateStepAmountOrUnit } from '../utils';
import * as errorMessage from '../../../../constants/ErrorMessages';
import { routes } from '../../../../config/routes';
import { useRouter } from 'next/router';
import {
  REGEX_NUMBER_INPUT_ONLY_STARTING_FROM_1,
  REGEX_NUMBERS_ONLY_WITH_ONLY_2_DECIMAL,
  NUMBER_INPUT_ONLY,
} from '../../../../constants/common';
import DisclaimerModalInfo from '../../../common/Footer/DisclaimerModal';
import CloseIcon from '../../../../assets/icons/close-icon.svg';
import NotePoints from '../../../common/NotePoints';
import TermsAndConditionInfo from '../TermsAndCondition';
import { StyledAlertModal } from '../../../../pages/transact/invest';
import { CHOOSE_NOMINEE_DETAILS_ERROR, EXPLORE_SCHEMES_USER_FLOW } from '../../../../constants/ExplorePage';
import { replaceAllOccurenceOfCharacter } from '../../schemeDetail/util';
import { useAppContext } from '../../../../store';
import { animateScroll as scroll, Element, scroller } from 'react-scroll';
import {
  INVESTMENT_TIME_FRAME_MAPPING_FOR_DROPDOWN,
  INVESTMENT_TIME_FRAME_MAPPING,
} from '../../../../constants/common';
import { formatValueForDropDown, convertArrayOfStringsToDropDownOptionsFormatWithSecondaryLabel } from './util';
import API from '../../../../API';
import * as constant from '../../../../constants/CartPage';
import twoFactorAuthenticationInfo from '../TwoFactorAuthenticationInvest';
import { TwoFAResponseDetails } from '../../transact/SwitchTransactionPage';
import twoFactorNoResponseInfo from '../NoResponseTwoFAAuth';
import FullPageLoader from '../../../common/FullPageLoader';
import { useDeviceType } from '../../../../utils/deviceType';
import CheckIcon from '../../../../assets/images/Check-Mobile-Icon.svg';
import DEVICE_TYPE from '../../../../constants/device';
import NomineeModal2FA from './NomineeModal2FA';
import { CutoffTiming } from '../../../../pages/cart';

interface InvestPageProps {
  hasAlreadyInvested: boolean;
  buyDetails: BuyDetailsProps;
  onHandleContinue: Function;
  onHandleAddToCart: Function;
  showLoaderAddToCart: boolean;
  fundCode: string;
  folioNumber: string;
  investmentId: string;
  isNfo: boolean;
  bankDetails: any;
  clearOtp: boolean;
  onVerifyOtp: Function;
  mobileNumber: string;
  emailId: string;
  investmentIdsDetails: Array<InvestmentIdDetails>;
  showPageLoader: boolean;
  showLoaderInOtp: boolean;
  setOpenVerifyOTPModal: Function;
  openVerifyOTPModal: boolean;
  redirectedFromPlanYourGoalWithSip: boolean;
  isRenewSip: boolean;
  schedule: string | string[];
  frequency: string;
  changeFundOption: Function;
  buyDetailsLoading: boolean;
  fundCodeOptionSelected: string;
  changeInvestmentId: Function;
  investmentIdSelected: string;
  isCustomerMinor: boolean;
  setMinorTurnedMajorCustomErrorModalOpen: Function;
  isMinorPoaInactive: boolean;
  setIsGuardianTransactionBlockedModal: Function;

  relationShipCodeDetails: Array<RelationShipCodes>;
  relationShipCodeObject: object;
  errorOccurredInBankApi: boolean;
  errorMessageOfBankApi?: string;
  setOpenJointHolderInvestmentErrorModal: Function;

  termsAndConditionGtmData?: Function; // For calling gtm function of TnC as per user flow
  addNomineeGtmData?: Function;
  editNomineeGtmData?: Function;
  closeOtpModalGtmData?: Function;
  closeNomineeModalGtmData?: Function;
  submitNomineeModalGtmData?: Function;
  addAnotherNomineeClickGtmData?: Function;
  removeNomineeClickGtmData?: Function;
  userFlow: string;
  invIdeaScheme: string;
  setStallJointInvestmentIdError: Function;
  stallJointInvestmentIdError: boolean;
  isNomineeError?: boolean;
  selectedInvestmentId?: InvestmentIdDetails;
}

interface GetDetailsData {
  cutOffDetails: {
    liquid: string;
    others: string;
    liquidSwitch: string;
  };
}
interface GetDetailsResponse {
  data?: {
    data?: GetDetailsData;
  };
}

interface ResponseStatus {
  statusMessage: string;
  statusType: string;
}

interface TwoFAResponseData {
  data?: {
    data: TwoFAResponseDetails;
    status?: ResponseStatus;
  };
}

interface NomineeDeclarationType {
  isModalOpen?: boolean;
  error?: boolean;
}

// const NomineeAccordion = (
//   heading,
//   isNomineeAccordionOpen,
//   nomineeDetails,
//   hasAlreadyInvested,
//   setIsNomineeAccordionOpen
// ) => (
//   <Accordion
//     heading={heading}
//     isOpen={isNomineeAccordionOpen}
//     setIsOpen={(bool) => setIsNomineeAccordionOpen(bool)}
//     // enableArrowForLargeScreen={true}
//     showCheckBox={true}
//   >
//     <NomineeDetailsBlock hasHeading={false} defaultNominee={nomineeDetails} />
//   </Accordion>
// );

const TermsAndConditionHeader = () => <ModalHeading>{constants.TERMS_AND_CONDITION}</ModalHeading>;
export default function InvestPage(props: InvestPageProps) {
  const {
    hasAlreadyInvested,
    buyDetails,
    onHandleContinue,
    fundCode,
    folioNumber,
    investmentId,
    isNfo,
    bankDetails,
    clearOtp,
    onVerifyOtp,
    mobileNumber,
    stallJointInvestmentIdError,
    emailId,
    investmentIdsDetails,
    showLoaderInOtp,
    showPageLoader,
    openVerifyOTPModal,
    setOpenVerifyOTPModal,
    redirectedFromPlanYourGoalWithSip,
    isRenewSip,
    schedule,
    onHandleAddToCart,
    showLoaderAddToCart,
    frequency,
    changeFundOption,
    buyDetailsLoading,
    fundCodeOptionSelected,
    changeInvestmentId,
    investmentIdSelected,
    relationShipCodeDetails,
    relationShipCodeObject,
    errorOccurredInBankApi,
    errorMessageOfBankApi,
    termsAndConditionGtmData,
    addNomineeGtmData,
    editNomineeGtmData,
    closeOtpModalGtmData,
    closeNomineeModalGtmData,
    submitNomineeModalGtmData,
    addAnotherNomineeClickGtmData,
    removeNomineeClickGtmData,
    userFlow,
    invIdeaScheme,
    setOpenJointHolderInvestmentErrorModal,
    setStallJointInvestmentIdError,
    isCustomerMinor,
    setMinorTurnedMajorCustomErrorModalOpen,
    selectedInvestmentId,
  } = props;
  const {
    accountHolder,
    acHolderDateOfBirth,
    dividendOptions,
    fundOptions,
    folioList,
    fundName,
    fundHouseId,
    latestNav,
    latestNavDate,
    maxNominee,
    minAmount,
    minSipAmount,
    minSipInstallment,
    minStepAmount,
    minStepSipAmount,
    preferredDates,
    isShowMonthlySip,
    isShowOneTime,
    isAxisSelect,
    customerRiskProfile,
    fundRiskProfile,
    fundSubCategory,
    investmentTimeframe,
    valueDate,
    defaultNominees,
    nomineeFromPreviousInvestment,
    constitutionCode,
    sipFrequencies,
  } = buyDetails || {};
  const [isNomineeAccordionOpen, setIsNomineeAccordionOpen] = useState(false);
  const [openNomineeModal, setOpenNomineeModal] = useState(false);
  const [nomineeDetails, setNomineeDetails] = useState({
    acceptedNomineeTerms: false,
    nominees: convertToDefaultNomineeUIFormat(defaultNominees),
  });
  const [isAddToCartCalled, setIsAddToCartCalled] = useState(false);
  const [transactionRequestData, setTransactionRequestData] = useState({});
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [errorMessageShownInModal, setErrorMessageShownInModal] = useState('');
  const [showOtpField, setShowOtpField] = useState(false);
  const [foliosObject, setFoliosObject] = useState({});
  const [minimumAmount, setMinimumAmount] = useState(minAmount);
  const [newInvestmentTimeFrame, setNewInvestmentTimeFrame] = useState(investmentTimeframe);
  const [investmentIdsObject, setInvestmentIdsObject] = useState<any>({});
  const [openRiskProfileMismatchModal, setOpenRiskProfileMismatchModal] = useState(false);
  // const [accountId, setAccountId] = useState(Object.keys(bankDetails)[0]);
  const [showTermsAndConditionModal, setShowTermsAndConditionModal] = useState(false);
  const [isBankBalanceInsufficientForTransaction, setIsBankBalanceInsufficeintForTransaction] = useState(false);
  const [isExistingFolio, setisExistingFolio] = useState(false);
  const { state, setState } = useAppContext();
  const [showNomineeDetails, setShowNomineeDetails] = useState<boolean>(true);
  const [showNomineeModal, setShowNomineeModal] = useState<boolean>(false);
  const [nomineeDetailsOptedError, setNomineeDetailsOptedError] = useState<boolean>();
  const [nomineeDetailsPresent, setNomineeDetailsPresent] = useState<string>('');
  const [isNewFolioNominee, setIsNewFolioNominee] = useState<boolean>(false);
  const [nomineeDeclarationOptOutChecked, setNomineeDeclarationOptOutChecked] = useState<boolean>(false);
  const [nomineeDeclarationOptInChecked, setNomineeDeclarationOptInChecked] = useState<boolean>(false);
  const [nomineeDeclarationOptOutError, setNomineeDeclarationOptOutError] = useState<boolean>(false);
  const [nomineeDeclarationOptInError, setNomineeDeclarationOptInError] = useState<boolean>(false);
  const [isTransactInvestJourney, setisTransactInvestJourney] = useState<boolean>(true);
  const [open2FAModal, setOpen2FAModal] = useState(false);
  const [errorMessageShownIn2FA, setErrorMessageShownIn2FA] = useState('');
  const [twoFAResponseData, setTwoFAResponseData] = useState(null);
  const [noDataFoundModal, setNoDataFoundModal] = useState(false);
  const [showLoader2FA, setShowLoader2FA] = useState(false);
  const [openNominationModal, setOpenNominationModal] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [optionalChecked, setOptionalChecked] = useState<boolean>(false);
  const [sipFreqSelected, setSIPFreqSelected] = useState('');
  const [minSIPAmount, setMinSIPAmount] = useState(0);
  const [minStepSIPAmount, setMinStepSIPAmount] = useState(0);
  const [maxStepSIPAmount, setMaxStepSIPAmount] = useState(0);
  const [minSIPInstallment, setMinSIPInstallment] = useState(0);
  const router = useRouter();
  const investmentAmountRef = React.createRef<HTMLInputElement>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isMobile = useDeviceType() === DEVICE_TYPE.MOBILE;

  const [cutOffTiming, setCutOffTiming] = useState<CutoffTiming>({
    liquid: null,
    others: null,
    liquidSwitch: null,
  });
  const [showNomineeDetailsError, setShowNomineeDetailsError] = useState<boolean>(false);
  const [panByInvestmendId, setPanByInvestmentId] = useState<string>('');

  const validateDefaultInvestmentId = () => {
    /*
      Validate the default investment Id used when the page loads
        1. Check if the first investment Id is of type Single / Joint
        2. IF: Inv_ID is Joint
          2.1. Check if corresponding folioList is empty / not empty
          2.2. IF: folioList is empty
            2.2.1. set flag to stall redirection from JointInvestmentIdErrorModal

    */
    const currentInvestmentId = investmentIdsDetails?.filter((id) => id.inv_ID == investmentIdSelected)[0];
    // Joint holder modal
    if (currentInvestmentId?.inv_ID == investmentIdsDetails[0]?.inv_ID) {
      //default selected
      if (currentInvestmentId?.mode_of_oper_ac == 'SI') {
        setStallJointInvestmentIdError(false);
        return;
      } else {
        if (folioNumber == 'New Folio' || folioList.length === 0) {
          setStallJointInvestmentIdError(false);
        } else {
          setStallJointInvestmentIdError(false);
        }
      }
    } else if (
      currentInvestmentId?.inv_ID == investmentIdsDetails?.filter((id) => id.inv_ID == investmentIdSelected)[0]?.inv_ID
    ) {
      setStallJointInvestmentIdError(false);
      //dropdown selected
      if (currentInvestmentId?.mode_of_oper_ac == 'SI') {
        return;
      } else {
        if (folioList.length == 0 || folioNumber == 'New Folio') {
          setStallJointInvestmentIdError(false);
        }
      }
    }
  };

  const validateNomineeDetailsVisible = (folioNumber?) => {
    /*
    ============ REFERENCE =============
    showNomineeDetails                -> flag to show/hide the nominee details radio options Yes and No
    nomineeDeclarationOptInChecked    -> flag set to true when Yes is selected, indicating customer has chosen to opt in nominee details
    nomineeDeclarationOptInError      -> flag set to true when Yes is selected but declaration is not checked
    nomineeDeclarationOptOutChecked   -> flag set to true when No is selected, indicating customer has chosen to opt out nominee details
    nomineeDeclarationOptOutError     -> flag set to true when No is selected but declaration is not checked
    nomineeDetailsOptedError          -> Error set while customer has not opted for Yes/No but tries to click continue
    nomineeDetailsPresent             -> constant Label Yes/No to match with the radio button label for UI rendering
    ====================================
   */

    //Check constitutionCode for HUF accounts (code 03) and allow txn with no nominee details & hide nominee options
    const isActiveInvestmentIdMinor =
      investmentIdsDetails?.filter((investmentId) => investmentId.inv_ID == investmentIdSelected)[0]?.isMinor == 'Y';
    if (constitutionCode == '03' || isActiveInvestmentIdMinor) {
      setShowNomineeDetails(false);
      setNomineeDeclarationOptInChecked(false);
      setNomineeDeclarationOptInError(false);
      setNomineeDeclarationOptOutChecked(true);
      setNomineeDeclarationOptOutError(false);
      setNomineeDetailsOptedError(false);
      setNomineeDetailsPresent(constants.NO);
    } else {
      if (folioList.length == 0 || folioNumber == 'New Folio') {
        //No Folios Present - Show nominees wrapper
        setShowNomineeDetails(true);
        //reset all nominee related flags
        setNomineeDetailsOptedError(false);
        setNomineeDeclarationOptInChecked(false);
        setNomineeDeclarationOptInError(false);
        setNomineeDeclarationOptOutChecked(false);
        setNomineeDeclarationOptOutError(false);
        setNomineeDetailsOptedError(false);
        setNomineeDetailsPresent('');
      } else {
        //Folios Present - Hide Nominee Wrapper
        //hide nominee Details Options
        setShowNomineeDetails(false);

        if (defaultNominees.length > 0) {
          //Atleast 1 Default Nominee present
          //allow txn with nominee details and nomineeStatus to true
          setNomineeDeclarationOptOutChecked(false);
          setNomineeDeclarationOptOutError(false);
          setNomineeDeclarationOptInChecked(true);
          setNomineeDeclarationOptInError(false);
          setNomineeDetailsOptedError(false);
          setNomineeDetailsPresent(constants.YES);
        } else {
          //No Default Nominees Present
          //allow txn with empty nominee details block and nomineeStatus to false
          setNomineeDeclarationOptInChecked(false);
          setNomineeDeclarationOptInError(false);
          setNomineeDeclarationOptOutChecked(true);
          setNomineeDeclarationOptOutError(false);
          setNomineeDetailsOptedError(false);
          setNomineeDetailsPresent(constants.NO);
        }
      }
    }
  };

  useEffect(() => {
    validateNomineeDetailsVisible();
    validateDefaultInvestmentId();
    console.warn(buyDetails);
  }, [buyDetails, folioList]);

  useEffect(() => {
    const NewFolio = {
      folioNumber: 'New Folio',
      investmentTimeFrame: investmentTimeframe,
      minAmount: minAmount,
    };
    if (folioList.length > 0) {
      setisExistingFolio(true);
    }
    folioList.push(NewFolio);
    const folioObject = convertArrayOfObjectToObject(folioList, 'folioNumber');
    setFoliosObject(folioObject);
    !hasAlreadyInvested
      ? setMinimumAmount(folioObject[Object.keys(folioObject)[0]]?.minAmount)
      : setMinimumAmount(folioObject[folioNumber]?.minAmount);
  }, [folioList]);

  const defaultTimeframe =
    buyDetails?.maximumTimeHorizon === 'N'
      ? INVESTMENT_TIME_FRAME_MAPPING_FOR_DROPDOWN['T7']
      : INVESTMENT_TIME_FRAME_MAPPING_FOR_DROPDOWN[buyDetails?.maximumTimeHorizon];
  const initialValues = {
    sipOrLumpsumOption:
      !redirectedFromPlanYourGoalWithSip && !isRenewSip && isShowOneTime ? constants.LUMPSUM : constants.SIP,
    growthOrDividendOption: dividendOptions && dividendOptions[0] === 'Growth' ? constants.GROWTH : constants.DIVIDEND,
    dividendOption: constants.PAYOUT,
    continue: false,
    termsAndCondition: false,
    nomineeSelected: false,
    amount: !redirectedFromPlanYourGoalWithSip && !isRenewSip && isShowOneTime ? 50000 : 5000,
    investmentTimeframe: defaultTimeframe,
    folioNumber: hasAlreadyInvested || isRenewSip ? folioNumber : Object.keys(foliosObject)[0],
    investmentId: hasAlreadyInvested ? investmentId : investmentIdSelected,
    //frequency: isRenewSip ? frequency.toUpperCase() : '',
    frequency: 'MONTHLY',
    noOfInstallment: undefined,
    scheduleDate: isRenewSip ? schedule : '',
    deviation: 'No',
    acctId: bankDetails && Object.keys(bankDetails)[0],
    hasAlreadyInvested: hasAlreadyInvested,
  };

  const validateNomineeOptions = () => {
    if (nomineeDetailsPresent == '') {
      setNomineeDetailsOptedError(true);
      scroller.scrollTo('nomineeWrapper', {
        smooth: true,
        offset: -280, // Scrolls to element - 280 pixels down the page
      });
      return false;
    } else if (nomineeDetailsPresent == constants.NO && nomineeDeclarationOptOutChecked == false) {
      setNomineeDeclarationOptOutError(true);
      setNomineeDetailsOptedError(false);
      scroller.scrollTo('nomineeWrapper', {
        smooth: true,
        offset: -280, // Scrolls to element - 280 pixels down the page
      });
      return false;
    }
    return true;
  };

  const ValidationSchema = yup.object({
    frequency: yup.string().when('sipOrLumpsumOption', {
      is: constants.SIP,
      then: yup.string().required('Please Select Frequency to proceed'),
      otherwise: yup.string().notRequired(),
    }),
    scheduleDate: yup.string().when('sipOrLumpsumOption', {
      is: constants.SIP,
      then: yup.string().required('Please select SIP date to proceed.'),
      otherwise: yup.string().notRequired(),
    }),
    // investmentTimeframe: yup.string().when('sipOrLumpsumOption', {
    //   is: constants.LUMPSUM,
    //   then: yup.string().required('Please select an investment time frame to proceed'),
    //   otherwise: yup.string().notRequired(),
    // }),
    //Above code is if the investmentTimeframe dropdown is only for Lumpsum
    investmentTimeframe: yup.string().required('Please select an investment time frame to proceed '),
    amount: yup.number().required('Please enter the amount'),
    noOfInstallment: yup.number().when('sipOrLumpsumOption', {
      is: constants.SIP,
      then: yup
        .number()
        .moreThan(minSIPInstallment - 1, `Min. ${minSIPInstallment}`)
        .lessThan(946, `Max. ${945}`),
      otherwise: yup.number().notRequired(),
    }),
    termsAndCondition: yup.boolean().when('continue', {
      is: true,
      then: yup
        .boolean()
        .required('Please agree to the Terms and Conditions to proceed.')
        .oneOf([true], 'Please agree to the Terms and Conditions to proceed.'),
    }),
    investmentId: yup
      .string()
      .when('hasAlreadyInvested', { is: false, then: yup.string().required('Please select investment id to proceed') }),
    folioNumber: yup
      .string()
      .when('hasAlreadyInvested', { is: false, then: yup.string().required('Please select folio number to proceed') }),
  });
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: ValidationSchema,
    enableReinitialize: true,
    validateOnMount: true,
    onSubmit: (values) => {
      if (stallJointInvestmentIdError) {
        //Default id selected (0th index) && customer to stay on the same page after joint holder error modal
        setOpenJointHolderInvestmentErrorModal(true);
      } else {
        if (isCustomerMinor == false)
          //customer has turned a major acc to minor-status api
          setMinorTurnedMajorCustomErrorModalOpen(true);
        else {
          if (validateNomineeOptions()) {
            shouldSendOtp(values.acctId);
          }
        }
      }
    },
  });

  const [noteData, setNoteData] = useState<any>();
  const getNote = () => {
    let tempNotes: any = [];
    const currentDate = new Date();
    const currentDay = currentDate.getDate();
    if (formik.values.sipOrLumpsumOption === 'SIP') {
      tempNotes.push(constants.SIP_NOTE_MESSAGE);
      if (currentDay >= 27) {
        tempNotes.push(constants.SIP_NEW_FOLIO_MESSAGE);
      }
    }
    if (isNfo) {
      constants.NFO_NOTE_POINTS(state.liquidCutOffTiming, state.otherCutOffTiming).map((item, index) => {
        tempNotes.push(item);
      });
    } else {
      constants
        .NOTE_POINTS(cutOffTiming?.liquid, cutOffTiming.others, cutOffTiming?.liquidSwitch)
        .map((item, index) => {
          tempNotes.push(item);
        });
    }
    setNoteData(tempNotes);
    console.warn(tempNotes);
    return tempNotes;
  };

  useEffect(() => {
    if (formik?.values?.sipOrLumpsumOption === constants.SIP) setSipDetails('MONTHLY');
    const notes = getNote();
  }, [formik.values.sipOrLumpsumOption, cutOffTiming]);

  const checkWhetherMFTransactionAllowed = (investmentIdsObject: object, investmentId: string) => {
    // const investmentIdsObject = convertArrayOfObjectToObject(investmentIdsDetails, 'inv_ID');
    if (investmentIdsObject[formik?.values?.investmentId]?.whetherMFTransactionAllowed === 'N') {
      setErrorMessageShownInModal(
        investmentIdsObject && Object.keys(investmentIdsObject).length > 1
          ? errorMessage.MULTIPLE_INVESTMENT_ID_TRANSACTION_NOT_ALLOWED(formik.values.investmentId)
          : errorMessage.ONE_INVESTMENT_ID_TRANSACTION_NOT_ALLOWED
      );
      setOpenErrorModal(true);
    } else if (investmentIdsObject[formik?.values?.investmentId]?.investmentAccountMismatch === 'Y') {
      setOpenErrorModal(true);
      setErrorMessageShownInModal(errorMessage.TAX_STATUS_MISMATCH);
    } else if (investmentIdsObject[formik?.values?.investmentId]?.inv_Status === 'F') {
      setOpenErrorModal(true);
      setErrorMessageShownInModal(errorMessage.FREEZE_ACCOUNT_NOT_ALLOWED);
    }
  };

  useEffect(() => {
    setInvestmentIdsObject(convertArrayOfObjectToObject(investmentIdsDetails, 'inv_ID'));
    // if (!hasAlreadyInvested) {
    //   checkWhetherMFTransactionAllowed(
    //     convertArrayOfObjectToObject(investmentIdsDetails, 'inv_ID'),
    //     formik.values.investmentId
    //   );
    //   // setMinimumAmount(foliosObject[Object.keys(foliosObject)[0]]?.minAmount);
    // }
    API.customer.getDetails().then((res: GetDetailsResponse) => {
      const response = res?.data?.data;
      setCutOffTiming({
        liquid: response?.cutOffDetails?.liquid,
        others: response?.cutOffDetails?.others,
        liquidSwitch: response?.cutOffDetails?.liquidSwitch,
      });
      setState({
        ...state,
        liquidCutOffTiming: response?.cutOffDetails?.liquid,
        otherCutOffTiming: response?.cutOffDetails?.others,
        liquidSwitch: response?.cutOffDetails?.liquidSwitch,
      });
    });
  }, []);

  useEffect(() => {
    if (investmentIdSelected) {
      API.customer.getPanByInvestmentId(investmentIdSelected).then((res: any) => {
        setPanByInvestmentId(res?.data?.data?.pan?.toUpperCase());
      });
    }
  }, [investmentIdSelected]);

  useEffect(() => {
    if (isRenewSip === true) {
      setSipDetails(frequency?.toUpperCase());
      // formik.values.frequency === 'MONTHLY';
    }
  }, [isRenewSip]);

  const resetFormValueOnChangeOfCheckBox = (fieldName: string, value: string) => {
    // the below commented formik logic is used when we need to disable the continue button, unless all the mandatory fields data is been entered by the user
    // currently this logic is removed, so in future if there is requirement to make the continue button disabled, u can uncomment the below commented formik code
    if (fieldName === 'sipOrLumpsumOption' && value === constants.LUMPSUM) {
      formik.setFieldValue('scheduleDate', '', false);
      formik.setFieldValue('noOfInstallment', '', false);
      formik.setFieldValue('amount', '', false);
      formik.setFieldValue('investmentTimeframe', defaultTimeframe, false);
      formik.setFieldValue('deviation', 'No');
      formik.setErrors({});
      formik.setTouched({});
      formik.setFieldValue('termsAndCondition', false, true);
      formik.setFieldError('termsAndCondition', undefined);
      formik.setFieldTouched('termsAndCondition', false);
      if (formik?.values?.folioNumber === 'New Folio') {
        setNomineeDetailsPresent('');
        setNomineeDeclarationOptOutChecked(false);
      }
      // formik.setFieldError('amount', undefined);
      // formik.setFieldError('noOfInstallment', undefined);
      // formik.setFieldError('scheduleDate', undefined);
      // formik.setFieldTouched('scheduleDate', false);
      // formik.setFieldTouched('noOfInstallment', false);
      // formik.setFieldTouched('amount', false);
    } else if (fieldName === 'sipOrLumpsumOption' && value === constants.SIP) {
      formik.setFieldValue('investmentTimeframe', defaultTimeframe, false);
      formik.setFieldValue('amount', '', false);
      formik.setFieldValue('deviation', 'No');
      formik.setErrors({});
      formik.setTouched({});
      formik.setFieldValue('termsAndCondition', false, true);
      formik.setFieldError('termsAndCondition', undefined);
      formik.setFieldTouched('termsAndCondition', false);
      if (formik?.values?.folioNumber === 'New Folio') {
        setNomineeDetailsPresent('');
        setNomineeDeclarationOptOutChecked(false);
      }
      // formik.setFieldError('amount', undefined);
      // formik.setFieldError('investmentTimeframe', undefined);
      // formik.setFieldError('scheduleDate', undefined);
      // formik.setFieldTouched('scheduleDate', false);
      // formik.setFieldTouched('investmentTimeframe', false);
      // formik.setFieldTouched('amount', false);
    }
  };

  const onHandleChange = (fieldName: string, value: any) => {
    const event = {
      target: {
        name: fieldName,
        value: value,
      },
    };

    resetFormValueOnChangeOfCheckBox(fieldName, value);
    if (fieldName === 'investmentId') {
      formik?.setFieldValue(fieldName, value);
    } else if (fieldName === 'amount' && value?.length > 0 && !NUMBER_INPUT_ONLY.test(value)) {
      // this condition is used to check that the entered amount doesn't contain more than 2 integer after the decimal point
      // formik.setFieldError('amount', 'You cannot Enter more than 2 integer after a decimal');
    } else if (
      fieldName === 'noOfInstallment' &&
      value.length > 0 &&
      !REGEX_NUMBER_INPUT_ONLY_STARTING_FROM_1.test(value)
    ) {
      // this condition is used to check the entered noOfInstalment doesn't have any decimal places
    } else {
      if (fieldName === 'acctId') {
        // setAccountId(value);
        formik.setFieldValue('acctId', value, false);
        if (bankDetails && Number(bankDetails[value]?.availableBalance) >= Number(formik.values.amount)) {
          // this block of code is executed when the availableBalance of the selected bank account is greater than or equal to investment amount
          setIsBankBalanceInsufficeintForTransaction(false);
          onContinue(value);
        } else {
          // when the availableBalance is less than investment amount, an inline error message is shown to the user
          // formik.setFieldError('acctId', errorMessage.CUSTOMER_SELECTS_BANK_ACCOUNT_WHICH_DOESNT_HAVE_ENOUGH_BALANCE);
          // formik.setFieldTouched('acctId', true);
          setIsBankBalanceInsufficeintForTransaction(true);
        }
        // shouldSendOtp(value);
      } else if (fieldName === 'folioNumber') {
        validateNomineeDetailsVisible(value);
        setMinimumAmount(foliosObject[value]?.minAmount);
        setNewInvestmentTimeFrame(foliosObject[value]?.investmentTimeFrame);
        if (value === 'New Folio') {
          setisExistingFolio(false);
          if (investmentIdsDetails?.filter((id) => id.inv_ID == investmentIdSelected)[0]?.mode_of_oper_ac == 'AS') {
            setOpenJointHolderInvestmentErrorModal(true);
          }
        } else {
          setisExistingFolio(true);
        }
      } else if (fieldName === 'sipOrLumpsumOption') {
        formik.setFieldValue('noOfInstallment', '');
        formik.setFieldValue('frequency', 'MONTHLY');
      } else if (fieldName === 'investmentTimeframe') {
        if (investmentTimeFrameSelectedMatchesUserRiskProfile(value, newInvestmentTimeFrame)) {
          formik.setFieldValue('deviation', 'Yes');
          setErrorMessageShownInModal(errorMessage.TIME_FRAME_MISMATCH_WITH_CUSTOMER_RISK_PROFILE);
          setOpenErrorModal(true);
        } else {
          formik.setFieldValue('deviation', 'No');
        }
      }
      formik.setFieldValue(fieldName, value);
    }
  };

  const shouldSendOtp = (acctId: string) => {
    if (
      validateStepAmountOrUnit(
        Number(formik?.values?.amount),
        formik?.values?.sipOrLumpsumOption === constants.SIP ? minStepSIPAmount : minStepAmount
      ) !== 0
    ) {
      setErrorMessageShownInModal(
        errorMessage.MIN_STEP_AMOUNT_ERROR(
          formik?.values?.sipOrLumpsumOption === constants.SIP ? minStepSIPAmount : minStepAmount
        )
      );
      setOpenErrorModal(true);
    } else if (formik?.values?.noOfInstallment && Number(formik?.values?.noOfInstallment) < minSIPInstallment) {
      // here we check that noOfInstallment is greater than minSipInstallment
      setErrorMessageShownInModal(errorMessage.NO_OF_MONTHS(minSIPInstallment));
      setOpenErrorModal(true);
    } else if (formik?.values?.noOfInstallment && Number(formik?.values?.noOfInstallment) > 945) {
      // here we check that noOfInstallment is greater than minSipInstallment
      setErrorMessageShownInModal(errorMessage.MAX_NO_OF_MONTHS(945));
      setOpenErrorModal(true);
    } else if (
      formik?.values?.amount &&
      Number(formik?.values?.amount) <
        (formik?.values?.sipOrLumpsumOption === constants.LUMPSUM ? minimumAmount : minSIPAmount)
    ) {
      setErrorMessageShownInModal(
        errorMessage.MIN_INVESTMENT_AMOUNT(
          formik?.values?.sipOrLumpsumOption === constants.LUMPSUM ? minimumAmount : minSIPAmount
        )
      );
      setOpenErrorModal(true);
    } else if (investmentIdsObject[formik?.values?.investmentId]?.whetherMFTransactionAllowed === 'N') {
      if (investmentIdsObject[formik?.values?.investmentId]?.isMinor === 'Y') {
        setOpenErrorModal(true);
        setErrorMessageShownInModal(errorMessage.GUARDIAN_VIA_MINOR_INVESTMENT_ID_POA_INACTIVE_TRANSACTION_PAGE_ERROR);
      } else {
        setErrorMessageShownInModal(
          investmentIdsObject && Object.keys(investmentIdsObject).length > 1
            ? errorMessage.MULTIPLE_INVESTMENT_ID_TRANSACTION_NOT_ALLOWED(formik.values.investmentId)
            : errorMessage.ONE_INVESTMENT_ID_TRANSACTION_NOT_ALLOWED
        );
        setOpenErrorModal(true);
      }
    } else if (investmentIdsObject[formik?.values?.investmentId]?.investmentAccountMismatch === 'Y') {
      setOpenErrorModal(true);
      setErrorMessageShownInModal(errorMessage?.TAX_STATUS_MISMATCH);
    } else if (investmentIdsObject[formik?.values?.investmentId]?.inv_Status === 'F') {
      setOpenErrorModal(true);
      setErrorMessageShownInModal(errorMessage?.FREEZE_ACCOUNT_NOT_ALLOWED);
    } else if (errorOccurredInBankApi) {
      setErrorMessageShownInModal(errorMessageOfBankApi);
      setOpenErrorModal(true);
    } else {
      if (bankDetails && Object.keys(bankDetails).length > 0) {
        if (
          bankDetails &&
          Number(bankDetails[formik?.values?.acctId]?.availableBalance) >= Number(formik?.values?.amount)
        ) {
          // if the available balance of the selected of first bank account is greater than or equal to investment amount, then we need to initiate the transaction
          setIsBankBalanceInsufficeintForTransaction(false);
          if (investmentTimeframe === 'N') {
            // formik.setFieldValue('deviation', 'Yes');
            //Below code is used if we want to show modal on click of continue
            // setErrorMessageShownInModal(
            //   errorMessage.CUSTOMER_RISK_PROFILE_DOEST_MATCH_WITH_SCHEME_RISK_PROFILE(customerRiskProfile)
            // );
            // setOpenRiskProfileMismatchModal(true);
            onContinue(formik?.values?.acctId);
          } else {
            onContinue(formik?.values?.acctId);
          }
        } else {
          if (bankDetails && Object.keys(bankDetails)?.length === 1) {
            // if the user has only 1 linked bank account for the given investment Id, and if the availableBalance is less than the investment amount, then we show him a error message, stating to populate the current bank account
            setErrorMessageShownInModal(errorMessage.CUSTOMER_SELECTS_BANK_ACCOUNT_WHICH_DOESNT_HAVE_ENOUGH_BALANCE);
            setOpenErrorModal(true);
          } else {
            // If the user has multiple linked bank account, and if the selected bank account or the initial bankAccount in the bankDetails list has its availableBalance
            // less than investment amount, then we need to show the verifyOtp modal, such that user can select another bank account with availableBalance greater than equal to investment amount
            setIsBankBalanceInsufficeintForTransaction(true);
            setOpenVerifyOTPModal(true);
          }
        }
      } else {
        // error message is displayed in pop-up modal when no bank account is linked for the selected investment Id
        setErrorMessageShownInModal(errorMessage.NO_BANK_DETAILS_LINKED_TO_SELECTED_INVESTMENT_ID);
        setOpenErrorModal(true);
      }
    }
  };

  const onContinue = (acctId: string) => {
    let requestData = {};
    formik?.values?.sipOrLumpsumOption === constants.LUMPSUM
      ? (requestData = {
          folioNum: formik?.values?.folioNumber === 'New Folio' ? '' : formik?.values?.folioNumber,
          investmentId: formik.values.investmentId,
          fundCode: fundCodeOptionSelected,
          amount: Number(formik?.values?.amount),
          investmentTimeframe: INVESTMENT_TIME_FRAME_MAPPING[formik?.values?.investmentTimeframe],
          selectedDividendOption:
            formik?.values?.growthOrDividendOption === constants.GROWTH
              ? constants.GROWTH
              : formik?.values?.dividendOption,
          deviation: investmentTimeframe === 'N' ? 'SCH_NOT_ALLOWED' : formik?.values?.deviation,
          accountNumber: acctId,
          nominees: hasAlreadyInvested
            ? nomineeDetailsPresent == constants.YES
              ? convertToDefaultNomineeDataFormat(
                  nomineeFromPreviousInvestment ? nomineeFromPreviousInvestment : nomineeDetails.nominees,
                  relationShipCodeObject,
                  optionalChecked
                )
              : []
            : nomineeDetailsPresent == constants.YES
            ? convertToDefaultNomineeDataFormat(nomineeDetails.nominees, relationShipCodeObject, optionalChecked)
            : [],
          addAsDefaultNomineeDetails: nomineeDetails?.acceptedNomineeTerms,
          nomineeStatus: nomineeDetailsPresent == constants.YES ? true : false,
        })
      : (requestData = {
          amount: Number(formik?.values?.amount),
          investmentTimeframe: INVESTMENT_TIME_FRAME_MAPPING[formik?.values?.investmentTimeframe],
          deviation: investmentTimeframe === 'N' ? 'SCH_NOT_ALLOWED' : formik?.values?.deviation,
          folioNum: formik?.values?.folioNumber === 'New Folio' ? '' : formik?.values?.folioNumber,
          investmentId: formik?.values?.investmentId,
          noOfInstallment:
            formik?.values?.noOfInstallment === '' || formik?.values?.noOfInstallment === undefined
              ? -1
              : Number(formik?.values?.noOfInstallment),
          addAsDefaultNomineeDetails: nomineeDetails?.acceptedNomineeTerms,
          nominees: hasAlreadyInvested
            ? isNomineeAccordionOpen && nomineeDetailsPresent == constants.YES
              ? convertToDefaultNomineeDataFormat(
                  nomineeFromPreviousInvestment,
                  relationShipCodeObject,
                  optionalChecked
                )
              : []
            : isNomineeAccordionOpen && nomineeDetailsPresent == constants.YES
            ? convertToDefaultNomineeDataFormat(nomineeDetails.nominees, relationShipCodeObject, optionalChecked)
            : [],
          scheduleDate: formik.values.scheduleDate,
          fundCode: fundCodeOptionSelected,
          selectedDividendOption:
            formik?.values?.growthOrDividendOption === constants.GROWTH
              ? constants.GROWTH
              : formik?.values?.dividendOption,
          // sipFrequency: sipFreqSelected,
          sipFrequency: 'MONTHLY',
          accountNumber: acctId,
          nomineeStatus: nomineeDetailsPresent == constants.YES ? true : false,
          isRenewSIP: isRenewSip ? true : false,
        });
    setTransactionRequestData(requestData);
    if (isAddToCartCalled) {
      if (formik?.values?.folioNumber !== 'New Folio')
        get2FADetails(requestData, onHandleAddToCart, formik?.values?.sipOrLumpsumOption === constants.LUMPSUM);
      else onHandleAddToCart(requestData, formik?.values?.sipOrLumpsumOption === constants.LUMPSUM);
    } else {
      if (formik?.values?.folioNumber !== 'New Folio')
        get2FADetails(requestData, onHandleContinue, formik?.values?.sipOrLumpsumOption === constants.LUMPSUM);
      else onHandleContinue(requestData, formik?.values?.sipOrLumpsumOption === constants.LUMPSUM);
    }
  };

  const onEdit = () => {
    setOpenNomineeModal(true);
    editNomineeGtmData();
  };

  const onNomineeDetailsSubmit = (nomineesDetail) => {
    setNomineeDetails(nomineesDetail);
    setIsNomineeAccordionOpen(true);
    submitNomineeModalGtmData();
  };

  const onOtpSubmit = (otp: string) => {
    if (otp.length === 0) {
      setOpenErrorModal(true);
      setErrorMessageShownInModal(errorMessage.CLICKED_SUBMIT_WITHOUT_ENTERING_OTP);
    } else {
      onVerifyOtp(otp);
    }
  };

  const onResendCode = () => {
    setOpenErrorModal(true);
    setErrorMessageShownInModal(errorMessage.OTP_SENT_MESSAGE);
    if (isAddToCartCalled) {
      onHandleAddToCart(transactionRequestData, formik?.values?.sipOrLumpsumOption === constants.LUMPSUM);
    } else {
      onHandleContinue(transactionRequestData, formik?.values?.sipOrLumpsumOption === constants.LUMPSUM);
    }
  };

  const setSipDetails = (frequencySelected: string) => {
    // Reset the form values of SIP whenever a new frequency is selected by user
    resetFormValueOnChangeOfCheckBox('MONTHLY', constants.SIP);

    // frequencySelected will be "MONTHLY", "QUARTERLY", etc
    const filteredFreq = sipFrequencies?.filter((sip) => sip?.displayName === frequencySelected)[0];
    setSIPFreqSelected(frequencySelected);
    setMinSIPAmount(filteredFreq?.minSipAmount);
    setMinSIPInstallment(filteredFreq?.minSipInstallment);
    setMinStepSIPAmount(filteredFreq?.minStepSipAmount);
    setMaxStepSIPAmount(25000);
  };

  // const Footer = () => (
  //   <FooterContainer>
  //     <ModalFooterWithConfirmation
  //       confirmMessage={'Ok'}
  //       shouldShowCancel={false}
  //       onClose={() => {
  //         formik.setFieldValue('deviation', 'No');
  //         setOpenErrorModal(false);
  //       }}
  //       onDone={() => {
  //         setOpenRiskProfileMismatchModal(false);
  //         onContinue(formik.values.acctId);
  //       }}
  //       className="otp-verification-modal"
  //     />
  //   </FooterContainer>
  // );

  const onOpenDetails = () => {
    const asRoute = `${routes.SCHEME_DETAIL.url}/${fundCode}${redirectedFromPlanYourGoalWithSip ? '?isSip=true' : ''}`;
    const schemeDetailRoute =
      asRoute +
      `${getQueryParamSymbol(asRoute)}fallBackTo=${routes.MUTUAL_FUND.url}&userFlow=${userFlow}${
        userFlow === EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS
          ? `&invIdeaScheme=${replaceAllOccurenceOfCharacter(invIdeaScheme?.toString(), ' & ', ' and ')}`
          : ''
      }`;
    router.push(schemeDetailRoute, asRoute, { shallow: true });
  };

  const NomineeDeclaration = () => (
    <>
      <NomineeDeclarationOptOutAccordionContents>
        <CheckBox
          checked={nomineeDeclarationOptOutChecked}
          onChange={() => {
            setNomineeDeclarationOptOutChecked(!nomineeDeclarationOptOutChecked);
            setNomineeDeclarationOptOutError(false);
          }}
        />
        <NomineeDeclarationOptOutAccordionText>
          {constants.NOMINEE_DECLARATION_OPT_OUT_MESSAGE}
        </NomineeDeclarationOptOutAccordionText>
      </NomineeDeclarationOptOutAccordionContents>
    </>
  );

  const NomineeDeclaration2FA = (props: NomineeDeclarationType) => (
    <>
      <NomineeDeclarationOptOutAccordionContents2FA>
        <CheckBox
          checked={nomineeDeclarationOptOutChecked}
          onChange={() => {
            setNomineeDeclarationOptOutChecked(!nomineeDeclarationOptOutChecked);
            setNomineeDeclarationOptOutError(false);
          }}
        />
        <NomineeDeclarationOptOutAccordionText>
          {constants.NOMINEE_DECLARATION_OPT_OUT_MESSAGE}
        </NomineeDeclarationOptOutAccordionText>
      </NomineeDeclarationOptOutAccordionContents2FA>
      {props?.isModalOpen && props?.error && (
        <AccordianErrorMessage>{constants.NOMINEE_DECLARATION_ERROR}</AccordianErrorMessage>
      )}
      {
        <ButtonWrapper2FA>
          <StyledConfirmButton
            onClick={async () => {
              if (!stallJointInvestmentIdError) {
                const isValidationSuccessful = validateNomineeOptions();
                if (isValidationSuccessful) {
                  shouldSendOtp(formik?.values?.acctId);
                  setIsModalOpen(false);
                }
              }
            }}
            primary
          >
            {constants.CONFIRM}
          </StyledConfirmButton>
        </ButtonWrapper2FA>
      }
    </>
  );

  const NomineeAccordion = (
    heading,
    isNomineeAccordionOpen,
    nomineeDetails,
    hasAlreadyInvested,
    setIsNomineeAccordionOpen
  ) => (
    <Accordion
      hideChevron={true}
      heading={heading}
      isOpen={isNomineeAccordionOpen}
      setIsOpen={(bool) => setIsNomineeAccordionOpen(bool)}
      // enableArrowForLargeScreen={true}
      showCheckBox={false}
      error={nomineeDeclarationOptOutError}
      errorMessage={constants.NOMINEE_DECLARATION_ERROR}
    >
      <NomineeDeclaration />
    </Accordion>
  );

  const NomineeAccordion2FA = (
    heading,
    isNomineeAccordionOpen,
    nomineeDetails,
    hasAlreadyInvested,
    setIsNomineeAccordionOpen
  ) => (
    <Accordion
      hideChevron={true}
      heading={heading}
      isOpen={isNomineeAccordionOpen}
      setIsOpen={(bool) => setIsNomineeAccordionOpen(bool)}
      // enableArrowForLargeScreen={true}
      showCheckBox={false}
      error={nomineeDeclarationOptOutError}
      errorMessage={constants.NOMINEE_DECLARATION_ERROR}
      isModalOpen={true}
    >
      <NomineeDeclaration2FA isModalOpen={true} error={nomineeDeclarationOptOutError} />
    </Accordion>
  );

  const handelFooterClick = (mode_of_oper_ac) => {
    if (mode_of_oper_ac) {
      setOpen2FAModal(false);
      setShowMore(false);
      formik.setFieldValue('folioNumber', 'New Folio', false);
      formik.setFieldValue('termsAndCondition', false);
      formik.setErrors({});
      formik.setTouched({});
      scroll.scrollTo(0);
      setShowNomineeDetails(false);
      setShowNomineeModal(true);
      setNomineeDetailsPresent('');
      setIsModalOpen(true);
      if (
        formik?.values?.amount &&
        Number(formik?.values?.amount) <
          (formik?.values?.sipOrLumpsumOption === constants.LUMPSUM ? minimumAmount : minSIPAmount)
      ) {
        setErrorMessageShownInModal(
          errorMessage.MIN_INVESTMENT_AMOUNT(
            formik?.values?.sipOrLumpsumOption === constants.LUMPSUM ? minimumAmount : minSIPAmount
          )
        );
        setOpenErrorModal(true);
        setOpen2FAModal(false);
        setIsModalOpen(false);
      }
    } else {
      router.push(routes.PORTFOLIO.url + `?investmentId=${investmentIdSelected}`);
    }
  };

  const FooterFor2FAOutflow = () => {
    const mode_of_oper_ac =
      investmentIdsDetails?.filter((id) => id?.inv_ID == investmentIdSelected)[0]?.mode_of_oper_ac == 'SI';
    return (
      <FooterContainer>
        <ModalFooterWithConfirmation
          confirmMessage={mode_of_oper_ac ? 'Continue With New Folio' : 'OK'}
          shouldShowCancel={false}
          onDone={async () => {
            handelFooterClick(mode_of_oper_ac);
          }}
          className="otp-verification-modal"
        />
      </FooterContainer>
    );
  };
  const get2FADetails = (requestData: any, handleSubmit: Function, isLumpsum: Boolean) => {
    setShowLoader2FA(true);
    let transType: string = isLumpsum ? 'AP' : 'SIP';
    API.customer
      .get2FADetails(requestData?.fundCode, requestData?.folioNum, transType, buyDetails?.orderId || '')
      .then((res: TwoFAResponseData) => {
        setShowLoader2FA(false);
        setTwoFAResponseData(res?.data?.data);

        if (res?.data?.data?.emailMatch && res?.data?.data?.mobileMatch) {
          if (res?.data?.data?.mobileMatch === 'Yes' || res?.data?.data?.emailMatch === 'Yes') {
            handleSubmit(requestData, isLumpsum);
          } else {
            setOpen2FAModal(true);
            setErrorMessageShownIn2FA('DETAILS_MISMATCH_2FA_API');
          }
        } else if (res?.data?.data?.errorMsg === 'Folio not available at RTA') {
          setNoDataFoundModal(true);
          setErrorMessageShownInModal(errorMessage.NO_DATA_FROM_CAMS_KARVY_INVEST);
        } else {
          setOpenErrorModal(true);
          setErrorMessageShownInModal(res?.data?.data.errorMsg);
        }
      })
      .catch((error) => {
        setShowLoader2FA(false);
        if (error.errorCode === 6007) {
          setOpen2FAModal(true);
          setErrorMessageShownIn2FA('NO_RESPONSE_2FA_API');
        } else {
          setOpenErrorModal(true);
          setErrorMessageShownInModal(error?.errorMsg?.message);
        }
      });
  };

  return (
    <InvestPageWrapper>
      {showTermsAndConditionModal && (
        <Modal
          onClose={() => setShowTermsAndConditionModal(false)}
          className="nominee-modal"
          HeaderComponent={TermsAndConditionHeader()}
        >
          <DisclaimerTextWrapper>
            <TermsAndConditionInfo />
          </DisclaimerTextWrapper>
        </Modal>
      )}
      {!isModalOpen && isNewFolioNominee && (
        <NomineeModal
          isOpen={openNomineeModal}
          onCloseModal={(shouldClose: boolean) => {
            setOpenNomineeModal(shouldClose);
            closeNomineeModalGtmData();
          }}
          nomineeDeclarationOptInChecked={nomineeDeclarationOptInChecked}
          setNomineeDeclarationOptInChecked={setNomineeDeclarationOptInChecked}
          nomineeDeclarationOptInError={nomineeDeclarationOptInError}
          setNomineeDeclarationOptInError={setNomineeDeclarationOptInError}
          setNomineeDetailsPresent={setNomineeDetailsPresent}
          fundHouseId={fundHouseId}
          accountHolder={accountHolder}
          documentObject={[]}
          documentType={[]}
          acHolderDateOfBirth={acHolderDateOfBirth}
          onNomineeDetailsSubmit={onNomineeDetailsSubmit}
          nomineesDetails={nomineeDetails}
          onAddNomineeClick={addAnotherNomineeClickGtmData}
          onRemoveNomineeClick={removeNomineeClickGtmData}
          optionalChecked={optionalChecked}
          setOptionalChecked={setOptionalChecked}
          maxNominee={maxNominee}
          selectedInvestmentId={selectedInvestmentId?.inv_ID ? selectedInvestmentId?.inv_ID : investmentId}
          tranType={formik.values.sipOrLumpsumOption === 'SIP' ? 'SIP' : 'Purchase'}
          panByInvestmentId={panByInvestmendId}
          {...{
            relationShipCodeDetails,
            relationShipCodeObject,
          }}
        />
      )}
      <VerifyOTPModal
        closeModal={() => {
          setOpenVerifyOTPModal(false);
          closeOtpModalGtmData();
        }}
        userFlow={userFlow}
        isOpen={openVerifyOTPModal}
        userDetails={{
          bankAccountNumbers: convertArrayOfStringsToDropDownOptionsFormat(Object.keys(bankDetails)),
          mobileNumber: mobileNumber || '',
          balance: bankDetails[formik?.values?.acctId]?.availableBalance,
          emailId: emailId || '',
        }}
        onConfirmedClicked={onOtpSubmit}
        className="profile-page-otp"
        onResendCode={onResendCode}
        clearOtp={clearOtp}
        isTransactionDone={true}
        formik={formik}
        isTransactInvestJourney={isTransactInvestJourney}
        onHandleChange={onHandleChange}
        selectedBankAccId={formik?.values?.acctId}
        // showOtpField={showOtpField}
        showLoader={showLoaderInOtp}
        isBankBalanceInsufficientForTransaction={isBankBalanceInsufficientForTransaction}
        isCustomerMinor={investmentIdsObject[formik?.values?.investmentId]?.isMinor === 'Y'}
      />
      {openErrorModal && (
        <StyledAlertModal
          className="alert-modal"
          wrapperClassname="alert-modal-wrapper"
          contentClassname="alert-modal-content"
          onClose={() => setOpenErrorModal(false)}
          mode="alert"
          showHeader={false}
          alertButtonText="Ok"
        >
          <StyledP1 dangerouslySetInnerHTML={{ __html: errorMessageShownInModal }} />
        </StyledAlertModal>
      )}
      {/* {openRiskProfileMismatchModal && (
        <StyledModal FooterComponent={Footer()} showHeader={false}>
          <RiskProfileMisMatchTextWrapper>
            <StyledP1 dangerouslySetInnerHTML={{ __html: errorMessageShownInModal }} />
            <StyledCloseIcon
              onClick={() => {
                setErrorMessageShownInModal('');
                setOpenRiskProfileMismatchModal(false);
              }}
            />
          </RiskProfileMisMatchTextWrapper>
        </StyledModal>
      )} */}
      {open2FAModal && (
        <Styled2FAModal
          onClose={() => {
            setOpen2FAModal(false);
            setShowMore(false);
            scroll.scrollTo(0);
            // router.push(routes.PORTFOLIO.url + `?investmentId=${investmentIdSelected}`);
          }}
          className="nominee-modal"
          FooterComponent={FooterFor2FAOutflow()}
          showHeader={false}
          // HeaderComponent={<></>}
        >
          <>
            <StyledCloseIcon2
              onClick={() => {
                setShowNomineeModal(false);
                if (folioNumber == 'New Folio' || formik?.values?.folioNumber == 'New Folio') {
                  setShowNomineeDetails(true);
                }
                setOpen2FAModal(false);
                setShowMore(false);
                scroll.scrollTo(0);
                // router.push(routes.PORTFOLIO.url + `?investmentId=${investmentIdSelected}`);
              }}
            />
            <DisclaimerTextWrapper2>
              {errorMessageShownIn2FA === 'DETAILS_MISMATCH_2FA_API'
                ? twoFactorAuthenticationInfo(
                    twoFAResponseData,
                    formik?.values?.folioNumber,
                    showMore,
                    setShowMore,
                    investmentIdsObject[formik?.values?.investmentId]['mode_of_oper_ac'] == 'SI'
                  )
                : twoFactorNoResponseInfo()}
              {/* {twoFactorAuthenticationInfo(twoFAResponseData, formik.values.folioNumber, showMore, setShowMore, true)} */}
            </DisclaimerTextWrapper2>
          </>
        </Styled2FAModal>
      )}

      {isModalOpen && (
        <StyledNomineeModal
          className="nominee-modal"
          showHeader={false}
          onClose={() => {
            setIsModalOpen(false);
          }}
        >
          <UpdateNomineeStyled
            hasAlreadyInvested={hasAlreadyInvested}
            nomineeSelected={isNomineeAccordionOpen}
            disable={showNomineeModal == false}
          >
            <Wrapper disable={false}>
              <AccordionWrapper disable={false}>
                {NomineeAccordion2FA(
                  <NomineeHeading>{constants.UPDATE_NOMINEE_DETAILS}</NomineeHeading>,
                  nomineeDetailsPresent === constants.NO,
                  nomineeDetails?.nominees,
                  hasAlreadyInvested,
                  setIsNomineeAccordionOpen
                )}
                <NominationOptions2FAWrapper>
                  <Radio
                    label={constants.YES}
                    value={constants.YES}
                    onClick={onEdit}
                    onChange={(e) => {
                      setNomineeDeclarationOptInChecked(false);
                      setNomineeDeclarationOptOutChecked(false);
                      setNomineeDeclarationOptOutError(false);
                      setNomineeDetailsPresent(e.target.value);
                      setNomineeDetailsOptedError(false);
                    }}
                    checked={nomineeDetailsPresent === constants.YES}
                  />
                  <Radio
                    label={constants.NO}
                    value={constants.NO}
                    onChange={(e) => {
                      setNomineeDeclarationOptOutChecked(false);
                      setNomineeDeclarationOptInChecked(false);
                      setNomineeDeclarationOptInError(false);
                      setNomineeDetailsPresent(e.target.value);
                      setNomineeDetailsOptedError(false);
                    }}
                    checked={nomineeDetailsPresent === constants.NO}
                  />
                </NominationOptions2FAWrapper>
              </AccordionWrapper>
              <NominationDetailsErrorContainer>
                {nomineeDetailsOptedError == true && (
                  <NominationErrorMessage>{CHOOSE_NOMINEE_DETAILS_ERROR}</NominationErrorMessage>
                )}
              </NominationDetailsErrorContainer>
            </Wrapper>

            <StyledCloseIcon2
              onClick={() => {
                setIsModalOpen(false);
                setOpen2FAModal(true);
                scroll.scrollTo(0);
              }}
            />
          </UpdateNomineeStyled>
          {nomineeDetailsPresent === constants.YES && (
            <NomineeModal2FA
              isOpen={openNomineeModal}
              onCloseModal={(shouldClose: boolean) => {
                setOpenNomineeModal(shouldClose);
                closeNomineeModalGtmData();
              }}
              nomineeDeclarationOptInChecked={nomineeDeclarationOptInChecked}
              setNomineeDeclarationOptInChecked={setNomineeDeclarationOptInChecked}
              nomineeDeclarationOptInError={nomineeDeclarationOptInError}
              setNomineeDeclarationOptInError={setNomineeDeclarationOptInError}
              setNomineeDetailsPresent={setNomineeDetailsPresent}
              fundHouseId={fundHouseId}
              accountHolder={accountHolder}
              onNomineeDetailsSubmit={onNomineeDetailsSubmit}
              nomineesDetails={nomineeDetails}
              onAddNomineeClick={addAnotherNomineeClickGtmData}
              onRemoveNomineeClick={removeNomineeClickGtmData}
              maxNominee={maxNominee}
              shouldSendOtp={shouldSendOtp}
              setIsModalOpen={setIsModalOpen}
              {...{
                relationShipCodeDetails,
                relationShipCodeObject,
              }}
            />
          )}
          {nomineeDetailsPresent === '' && (
            <UpdateNomineeWrapper>
              <StyledCheckIcon></StyledCheckIcon>
              <StyledNomineeMsg>
                <StyledNomineeText>
                  As per SEBI guidelines, you are required to opt if you would<br></br>
                  like to update nominee details before making a transaction <br></br>in a new Folio.
                </StyledNomineeText>
                <StyledNomineeText>
                  Please select YES or NO above to proceed further with <br></br>your transaction.
                </StyledNomineeText>
              </StyledNomineeMsg>
            </UpdateNomineeWrapper>
          )}
        </StyledNomineeModal>
      )}
      {noDataFoundModal && (
        <StyledAlertModal
          className="alert-modal"
          wrapperClassname="alert-modal-wrapper"
          contentClassname="alert-modal-content"
          onClose={() => {
            setNoDataFoundModal(false);
            if (isAddToCartCalled) {
              onHandleAddToCart(transactionRequestData, formik?.values?.sipOrLumpsumOption === constants.LUMPSUM);
            } else {
              onHandleContinue(transactionRequestData, formik?.values?.sipOrLumpsumOption === constants.LUMPSUM);
            }
            // onClickProceed(requestData2FA, transactionData2FA?.oneTimeOrSystematic === constants.SYSTEMATIC);
          }}
          mode="alert"
          showHeader={false}
        >
          <StyledP1 dangerouslySetInnerHTML={{ __html: errorMessageShownInModal }} />
        </StyledAlertModal>
      )}
      {showLoader2FA && <FullPageLoader />}
      <StyledRow>
        <StyledCol xs={12}>
          <InvestPageCardContainer hasAlreadyInvested={hasAlreadyInvested} nomineeSelected={isNomineeAccordionOpen}>
            <InvestmentDetailCardWrapper
              nomineeSelected={isNomineeAccordionOpen}
              hasAlreadyInvested={hasAlreadyInvested}
            >
              <InvestSchemeDetailCard
                onChange={onHandleChange}
                changeFundOption={changeFundOption}
                isNfo={isNfo}
                {...{
                  fundName,
                  latestNav,
                  latestNavDate,
                  isAxisSelect,
                  dividendOptions,
                  formik,
                  fundRiskProfile,
                  fundHouseId,
                  onOpenDetails,
                  fundOptions,
                  hasAlreadyInvested,
                  buyDetailsLoading,
                  fundCodeOptionSelected,
                }}
              />
            </InvestmentDetailCardWrapper>
          </InvestPageCardContainer>
          {buyDetailsLoading ? (
            <DotLoaderWrapper>
              <StyledDotLoader large={false} primary />
            </DotLoaderWrapper>
          ) : (
            <TransactionCardWrapper hasAlreadyInvested={hasAlreadyInvested} nomineeSelected={isNomineeAccordionOpen}>
              <TransactionCard
                onChange={onHandleChange}
                nomineeSelected={isNomineeAccordionOpen}
                {...{
                  formik,
                  hasAlreadyInvested,
                  preferredDates,
                  isShowMonthlySip,
                  isShowOneTime,
                  minimumAmount,
                  minSipAmount,
                  accountHolder,
                  bankDetails,
                  foliosObject,
                  folioList,
                  investmentIdsDetails,
                  redirectedFromPlanYourGoalWithSip,
                  isRenewSip,
                  valueDate,
                  buyDetails,
                  changeInvestmentId,
                  minSipInstallment,
                  isNfo,
                  fundCodeOptionSelected,
                  sipFrequencies,
                }}
              />
              {!stallJointInvestmentIdError && (
                <Element name="nomineeWrapper">
                  {isMobile ? (
                    <NomineeWrapper
                      hasAlreadyInvested={hasAlreadyInvested}
                      nomineeSelected={isNomineeAccordionOpen}
                      // disable={
                      //   maxNominee === 0 ||
                      //   (hasAlreadyInvested && nomineeFromPreviousInvestment && nomineeFromPreviousInvestment.length === 0) ||
                      //   isExistingFolio
                      // }
                      disable={showNomineeDetails == false}
                    >
                      <Wrapper disable={false}>
                        <AccordionWrapperMobile disable={false}>
                          {NomineeAccordion(
                            <NomineeHeading>{constants.NOMINEE_DETAILS}</NomineeHeading>,
                            nomineeDetailsPresent === constants.NO,
                            nomineeDetails?.nominees,
                            hasAlreadyInvested,
                            setIsNomineeAccordionOpen
                          )}

                          <NominationOptionsWrapperMobile>
                            <Radio
                              label={constants.YES}
                              value={constants.YES}
                              onClick={onEdit}
                              onChange={(e) => {
                                setIsNewFolioNominee(true);
                                setNomineeDeclarationOptOutChecked(false);
                                setNomineeDeclarationOptOutError(false);
                                setNomineeDetailsPresent(e.target.value);
                                setNomineeDetailsOptedError(false);
                              }}
                              checked={nomineeDetailsPresent === constants.YES}
                            />
                            <Radio
                              label={constants.NO}
                              value={constants.NO}
                              onChange={(e) => {
                                setNomineeDeclarationOptInChecked(false);
                                setNomineeDeclarationOptInError(false);
                                setNomineeDetailsPresent(e.target.value);
                                setNomineeDetailsOptedError(false);
                              }}
                              checked={nomineeDetailsPresent === constants.NO}
                            />
                          </NominationOptionsWrapperMobile>
                        </AccordionWrapperMobile>
                        <NominationDetailsErrorContainer>
                          {nomineeDetailsOptedError == true && (
                            <NominationErrorMessage>{CHOOSE_NOMINEE_DETAILS_ERROR}</NominationErrorMessage>
                          )}
                        </NominationDetailsErrorContainer>
                      </Wrapper>
                    </NomineeWrapper>
                  ) : (
                    !isModalOpen && (
                      <NomineeWrapper
                        hasAlreadyInvested={hasAlreadyInvested}
                        nomineeSelected={isNomineeAccordionOpen}
                        // disable={
                        //   maxNominee === 0 ||
                        //   (hasAlreadyInvested && nomineeFromPreviousInvestment && nomineeFromPreviousInvestment.length === 0) ||
                        //   isExistingFolio
                        // }
                        disable={showNomineeDetails == false}
                      >
                        <Wrapper disable={false}>
                          <AccordionWrapper disable={false}>
                            {NomineeAccordion(
                              <NomineeHeading>{constants.NOMINEE_DETAILS}</NomineeHeading>,
                              nomineeDetailsPresent === constants.NO,
                              nomineeDetails?.nominees,
                              hasAlreadyInvested,
                              setIsNomineeAccordionOpen
                            )}

                            <NominationOptionsWrapper>
                              <Radio
                                label={constants.YES}
                                value={constants.YES}
                                onClick={onEdit}
                                onChange={(e) => {
                                  setIsNewFolioNominee(true);
                                  setNomineeDeclarationOptOutChecked(false);
                                  setNomineeDeclarationOptOutError(false);
                                  setNomineeDetailsPresent(e.target.value);
                                  setNomineeDetailsOptedError(false);
                                }}
                                checked={nomineeDetailsPresent === constants.YES}
                              />
                              <Radio
                                label={constants.NO}
                                value={constants.NO}
                                onChange={(e) => {
                                  setNomineeDeclarationOptInChecked(false);
                                  setNomineeDeclarationOptInError(false);
                                  setNomineeDetailsPresent(e.target.value);
                                  setNomineeDetailsOptedError(false);
                                }}
                                checked={nomineeDetailsPresent === constants.NO}
                              />
                            </NominationOptionsWrapper>
                          </AccordionWrapper>
                          <NominationDetailsErrorContainer>
                            {nomineeDetailsOptedError == true && (
                              <NominationErrorMessage>{CHOOSE_NOMINEE_DETAILS_ERROR}</NominationErrorMessage>
                            )}
                          </NominationDetailsErrorContainer>
                        </Wrapper>
                      </NomineeWrapper>
                    )
                  )}
                </Element>
              )}
            </TransactionCardWrapper>
          )}

          <OtherDetailsCard
            onChange={onHandleChange}
            isOpen
            {...{
              formik,
              buyDetails,
            }}
          ></OtherDetailsCard>
        </StyledCol>
        <StyledCol xs={12}>
          <Element name="termsAndCondition">
            <TermsAndConditionWrapper>
              <StyledInputCheckBox
                name="termsAndCondition"
                checked={formik?.values?.termsAndCondition}
                onChange={() => onHandleChange('termsAndCondition', !formik?.values?.termsAndCondition)}
              />
              <StyledP1>
                I have read and understood the information requirements and the
                <TermsAndConditionText
                  onClick={() => {
                    setShowTermsAndConditionModal(true);
                    termsAndConditionGtmData();
                  }}
                >
                  &nbsp;Terms & Conditions&nbsp;
                </TermsAndConditionText>
                mentioned and I hereby accept the same.
              </StyledP1>
            </TermsAndConditionWrapper>
          </Element>
          {formik?.errors?.termsAndCondition && formik?.touched?.termsAndCondition && (
            <StyledErrorMessage>{formik?.errors?.termsAndCondition}</StyledErrorMessage>
          )}
        </StyledCol>
        <StyledCol xs={12}>
          <NotePoints notData={noteData} showRegulatoryNote={true} />
        </StyledCol>
        {!buyDetailsLoading && (
          <StyledCol xs={12}>
            <ButtonWrapper isMobile={isMobile}>
              <StyledButtonWrapper>
                <StyledButton
                  onClick={async () => {
                    await formik.setFieldValue('continue', false, true);
                    setIsAddToCartCalled(true);
                    if (!stallJointInvestmentIdError) {
                      validateNomineeOptions();
                    }
                    formik.handleSubmit();
                    const { termsAndCondition, ...errors } = formik?.errors;
                    // below logic is used when any value is left blank in bottom of page and customer is at top of page and selects continue
                    // then he will be taken to bottom of page and vice versa
                    if (errors && Object.keys(errors).length > 0) {
                      scroll.scrollTo(180);
                    } else if (!formik.values.termsAndCondition) {
                      scroller.scrollTo('termsAndCondition', {
                        smooth: true,
                        offset: -150, // Scrolls to element - 150 pixels down the page
                      });
                    }
                  }}
                  // disabled={!(formik.isValid && formik.dirty)}
                  loading={showLoaderAddToCart}
                  primary
                >
                  {constant.ADD_TO_CART}
                </StyledButton>
                <StyledButton
                  onClick={async () => {
                    setIsAddToCartCalled(false);
                    await formik.setFieldValue('continue', true, true);
                    if (!stallJointInvestmentIdError) {
                      validateNomineeOptions();
                    }
                    console.warn('Continue');
                    formik.handleSubmit();
                    const { termsAndCondition, ...errors } = formik?.errors;
                    // below logic is used when any value is left blank in bottom of page and customer is at top of page and selects continue
                    // then he will be taken to bottom of page and vice versa
                    if (errors && Object.keys(errors).length > 0) {
                      scroll.scrollTo(180);
                    } else if (!formik.values.termsAndCondition) {
                      scroller.scrollTo('termsAndCondition', {
                        smooth: true,
                        offset: -150, // Scrolls to element - 150 pixels down the page
                      });
                    }
                  }}
                  // disabled={!(formik.isValid && formik.dirty)}
                  loading={showPageLoader}
                  primary
                >
                  {constants.CONTINUE}
                </StyledButton>
              </StyledButtonWrapper>
            </ButtonWrapper>
          </StyledCol>
        )}
      </StyledRow>
    </InvestPageWrapper>
  );
}

const InvestPageWrapper = styled.div`
  padding-top: ${pxToRem(8)};
  position: relative;
  padding-bottom: ${pxToRem(24)};
`;

const StyledCheckIcon = styled(CheckIcon)`
  margin-left: 0px;
  margin-top: 30px;
  margin-bottom: 25px;
`;

const UpdateNomineeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledRow = styled(Row)`
  padding: 0;
  margin: 0;
`;

const StyledCol = styled(Col)`
  padding: 0;
  margin: 0;
`;

const FooterContainer = styled.div`
  width: 100%;
  ${up('md')} {
    text-align: end;
  }
`;

const InvestPageCardContainer = styled.div<{ hasAlreadyInvested?: boolean; nomineeSelected: boolean }>`
  box-shadow: ${(props) => (props.hasAlreadyInvested ? `none` : `0 ${pxToRem(2)} ${pxToRem(8)} #00000029`)};
  border-radius: ${(props) => (props.hasAlreadyInvested ? `none` : `${pxToRem(8)}`)};
  margin-bottom: ${pxToRem(16)};
  ${up('md')} {
    box-shadow: ${(props) =>
      props.nomineeSelected && props.hasAlreadyInvested ? `none` : `0 ${pxToRem(2)} ${pxToRem(8)} #00000029`};
    border-radius: ${(props) => (props.nomineeSelected && props.hasAlreadyInvested ? `none` : `${pxToRem(8)}`)};
    margin-bottom: ${pxToRem(24)};
  }
`;

const InvestmentDetailCardWrapper = styled.article<{ hasAlreadyInvested?: boolean; nomineeSelected: boolean }>`
  background-color: #ffffff;
  border-radius: ${(props) => (props.hasAlreadyInvested ? `${pxToRem(8)}` : `${pxToRem(8)} ${pxToRem(8)} 0 0`)};
  box-shadow: ${(props) => (props.hasAlreadyInvested ? `0 ${pxToRem(2)} ${pxToRem(8)} #00000029` : `0`)};
  margin-bottom: ${(props) => (props.hasAlreadyInvested ? ` ${pxToRem(16)}` : `none`)};
  ${up('md')} {
    border-radius: ${(props) =>
      props.hasAlreadyInvested && props.nomineeSelected
        ? `${pxToRem(8)}`
        : `${pxToRem(8)} ${pxToRem(8)} ${pxToRem(8)} ${pxToRem(8)}`};
    box-shadow: ${(props) =>
      props.hasAlreadyInvested && props.nomineeSelected ? `0 ${pxToRem(2)} ${pxToRem(8)} #00000029` : `none`};
    margin-bottom: ${(props) => (props.hasAlreadyInvested && props.nomineeSelected ? ` ${pxToRem(24)}` : `0`)};
  }
`;

const TransactionCardWrapper = styled.article<{ hasAlreadyInvested?: boolean; nomineeSelected: boolean }>`
  background-color: #ffffff;
  border-radius: ${(props) => (props.hasAlreadyInvested ? `${pxToRem(8)}` : `0 0 ${pxToRem(8)} ${pxToRem(8)} `)};
  //box-shadow: ${(props) => (props.hasAlreadyInvested ? `0 ${pxToRem(2)} ${pxToRem(8)} #00000029` : `none`)};
  box-shadow: 0 ${pxToRem(2)} ${pxToRem(8)} #00000029;
  margin-bottom: ${(props) => (props.hasAlreadyInvested ? ` ${pxToRem(16)}` : `0`)};
  ${up('md')} {
    border-radius: ${(props) =>
      props.hasAlreadyInvested && props.nomineeSelected
        ? `${pxToRem(8)}`
        : `${pxToRem(8)} ${pxToRem(8)} ${pxToRem(8)} ${pxToRem(8)} `};
    // box-shadow: ${(props) =>
      props.hasAlreadyInvested && props.nomineeSelected ? `0 ${pxToRem(2)} ${pxToRem(8)} #00000029` : `none`};
    box-shadow: 0 ${pxToRem(2)} ${pxToRem(8)} #00000029;
    margin-bottom: ${(props) => (props.hasAlreadyInvested && props.nomineeSelected ? ` ${pxToRem(24)}` : `0`)};
  }
`;

const NomineeWrapper = styled.div<{ hasAlreadyInvested?: boolean; nomineeSelected: boolean; disable?: boolean }>`
  display: ${(props) => (props.disable ? 'none' : 'flex')};
  background-color: #ffffff;
  //border-radius: ${(props) => (props.hasAlreadyInvested ? `${pxToRem(8)}` : `0 0 ${pxToRem(8)} ${pxToRem(8)} `)};
  box-shadow: ${(props) => (props.hasAlreadyInvested ? `0 ${pxToRem(2)} ${pxToRem(8)} #00000029` : `none`)};
  margin-bottom: ${(props) => (props.hasAlreadyInvested ? ` ${pxToRem(16)}` : `none`)};
  //padding: ${(props) => (props.disable ? 'none' : `${pxToRem(8)}`)};
  ${up('md')} {
    // padding: ${pxToRem(16)};
    border: #ff0000;
    border-radius: ${(props) =>
      props.hasAlreadyInvested && props.nomineeSelected
        ? `${pxToRem(8)}`
        : `${pxToRem(8)} ${pxToRem(8)} ${pxToRem(8)} ${pxToRem(8)} `};
    box-shadow: ${(props) =>
      props.hasAlreadyInvested && props.nomineeSelected ? `0 ${pxToRem(2)} ${pxToRem(8)} #00000029` : `none`};
    margin-bottom: ${(props) =>
      props.hasAlreadyInvested && props.nomineeSelected ? ` ${pxToRem(16)}` : `${pxToRem(16)}`};
    width: 600px;
    background-color: #ffffff;
    margin-left: 25px;
    outline: 1px solid #ececec;
  }
`;

const UpdateNomineeStyled = styled.div<{ hasAlreadyInvested?: boolean; nomineeSelected: boolean; disable?: boolean }>`
  display: ${(props) => (props.disable ? 'none' : 'flex')};
  border-radius: 10px 10px 0 0;
  background-color: #ececec;
  height: 90px;
`;

const AddNomineeWrapper = styled.div<{ disable: boolean }>`
  display: ${(props) => (props.disable ? 'none' : 'flex')};
  margin: ${pxToRem(4)} ${pxToRem(8)};
  cursor: pointer;
`;

const StyledB1 = styled(B1)`
  color: #4a4a4a;
  padding-right: ${pxToRem(12)};
`;

const AccordionWrapper = styled.div<{ disable: boolean }>`
  position: relative;
 // outline: 1px solid white;
 // padding-left: ${pxToRem(8)};
  display: ${(props) => (props.disable ? 'none' : 'flex')};
  width: 100%;
  padding-top: 15px;
  border-radius: ${pxToRem(8)} : ${pxToRem(8)} ${pxToRem(8)} 0 0 ;
`;

const AccordionWrapperMobile = styled.div<{ disable: boolean }>`
  position: relative;
 // outline: 1px solid white;
 // padding-left: ${pxToRem(8)};
  display: ${(props) => (props.disable ? 'none' : 'flex')};
  width: 100%;
  padding-top: 10px;
  background-color: #ECECEC;
  //height: 40px;
  border-radius: 0px 0px 3px 3px;
  border-radius: ${pxToRem(8)} : ${pxToRem(8)} ${pxToRem(8)} 0 0 ;
`;

const NominationOptionsWrapper = styled.article`
  position: absolute;
  width: 6rem;
  //padding-top: ${pxToRem(0)};
  //left: ${pxToRem(250)};
  display: flex;
  justify-content: space-between;
  ${up('md')} {
    padding-top: ${pxToRem(0)};
    left: ${pxToRem(420)};
    width: 8rem;
  }
`;

const NominationOptions2FAWrapper = styled.article`
  position: absolute;
  width: 6rem;
  display: flex;
  justify-content: center;
  margin-top: 25px;
  padding-top: 10px;
  margin-left: 20px;
  gap: 6px;
  ${up('md')} {
    padding-top: ${pxToRem(0)};
    width: 8rem;
    margin-top: 32px;
    margin-left: 18px;
    display: flex;
    justify-content: space-around;
  }
`;

const NominationOptionsWrapperMobile = styled.article`
  position: absolute;
  width: 6rem;
  //padding-top: ${pxToRem(0)};
  //left: ${pxToRem(250)};
  display: flex;
  justify-content: space-between;
  margin-left: 220px;
  ${up('md')} {
    padding-top: ${pxToRem(0)};
    //left: ${pxToRem(420)};
    width: 8rem;
  }
`;

const Nominationwrapper = styled.div`
background-color:#ECECEC;
position: relative;
border-radius: ${pxToRem(8)} : ${pxToRem(8)} ${pxToRem(8)} 0 0 ;
//margin-bottom:  ${pxToRem(16)};
height:${pxToRem(40)};
${up('md')} {
  border-radius: ${pxToRem(8)} ${pxToRem(8)} 0 0 ;
}
`;

const StyledLinkedLabel = styled(P1)`
  color: ${(props) => props.theme.palette.burgundy1};
  cursor: pointer;
  padding-left: ${pxToRem(12)};
`;

const StyledNomineeText = styled(P2)`
  color: ${(props) => props.theme.palette.grey2};
  font-family: math;
`;

const StyledP2 = styled(P2)`
  color: ${(props) => props.theme.palette.grey2};
  font-style: italic;
`;

const TermsAndConditionWrapper = styled.article`
  display: flex;
  padding-top: ${pxToRem(16)};
`;

const StyledP1 = styled(P1)`
  color: ${(props) => props.theme.palette.grey2};
  align-self: center;
`;

const StyledInputCheckBox = styled(CheckBox)`
  padding-top: 0;
  align-self: flex-start;
`;

const ButtonWrapper = styled.article<{ isMobile?: boolean }>`
  display: flex;
  margin-top: ${(props) => (props.isMobile ? `0` : `${pxToRem(24)}`)};
  margin-bottom: ${(props) => (props.isMobile ? `0` : `${pxToRem(80)}`)};
  ${up('md')} {
    justify-content: flex-end;
    margin-bottom: ${pxToRem(64)};
  }
`;

const ButtonWrapper2FA = styled.article`
  display: flex;
  margin-left: 16px;
  margin-right: 16px;
  margin-bottom: 16px;
  ${up('md')} {
    justify-content: flex-end;
  }
`;

const StyledButtonWrapper = styled.div`
  display: flex;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  max-width: 100%;
  z-index: 1000;
  background: ${(props) => props.theme.palette.white};
  padding-top: ${pxToRem(12)};
  padding-bottom: ${pxToRem(12)};
  border-top-left-radius: ${pxToRem(12)};
  border-top-right-radius: ${pxToRem(12)};
  ${up('md')} {
    max-width: 100%;
    background: none;
    position: relative;
  }
`;

const StyledButton = styled(Button)`
  width: 100%;
  margin: 0 ${pxToRem(12)};
  ${up('md')} {
    margin: 0;
    margin: 0 0 0 ${pxToRem(12)};
    width: ${pxToRem(130)};
  }
`;

const Wrapper = styled.div<{ disable: boolean }>`
  display: ${(props) => (props.disable ? 'none' : 'inline-block')};
  width: 100%;
`;

const NomineeHeading = styled.div`
  margin-left: 20px;
  margin-bottom: 10px;
`;

const StyledErrorMessage = styled(P2)`
  color: ${(props) => props.theme.palette.red1};
  padding: 0;
  margin: 0;
  font-style: italic;
  margin-block-end: 0;
  margin-block-start: 0;
`;

const NominationErrorMessage = styled(P2)`
  color: ${(props) => props.theme.palette.red1};
  padding: 0;
  margin: 0;
  font-style: italic;
  margin-block-end: 0;
  margin-block-start: 0;
`;

const NominationDetailsErrorContainer = styled.div`
  // padding: 0.2rem 0 0 0.5rem;
`;

const TermsAndConditionText = styled.span`
  color: ${(props) => props.theme.palette.burgundy1};
  padding: 0;
  margin: 0;
  margin-block-end: 0;
  margin-block-start: 0;
  cursor: pointer;
`;

const ModalHeading = styled(H5)`
  color: ${(props) => props.theme.palette.black};
  padding: ${pxToRem(8)};
  ${up('md')} {
    padding: ${pxToRem(16)};
  }
`;

const DisclaimerTextWrapper = styled.div`
  max-height: 60%;
  height: ${pxToRem(329)};
  overflow: auto;
`;
const DisclaimerTextWrapper2 = styled.div`
  //max-height: ${pxToRem(620)};
  //overflow: auto;
`;

const DotLoaderWrapper = styled.div`
  text-align: center;
  background-color: ${(props) => props.theme.palette.white};
`;
const StyledDotLoader = styled(DotLoader)`
  margin-bottom: ${pxToRem(20)};
`;

const RiskProfileMisMatchTextWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  ${up('md')} {
  }
`;

const StyledCloseIcon = styled(CloseIcon)`
  width: ${pxToRem(56)};
  cursor: pointer;
`;
const StyledCloseIcon2 = styled(CloseIcon)`
  width: ${pxToRem(56)};
  cursor: pointer;
  position: absolute;
  top: 0.5rem;
  right: -1.2rem;
  ${up('md')} {
    top: 0.5rem;
    right: -1rem;
  }
`;

const StyledModal = styled(Modal)`
  .modal-body {
    padding-bottom: 0;
  }
  .modal-content {
    top: 27%;
  }
`;

const NomineeDeclarationOptOutAccordionContents = styled.div`
  display: flex;
  align-items: flex-start;
  background-color: ${(props) => props.theme.palette.whiteGrey3};
  padding: 12px;
`;

const NomineeDeclarationOptOutAccordionContents2FA = styled.div`
  display: flex;
  align-items: flex-start;
  //background-color: ${(props) => props.theme.palette.whiteGrey3};
  padding: 12px;
  width: 95%;
  padding-top: 30px;
`;

const NomineeDeclarationOptOutAccordionText = styled(P1)``;

const NomineeDetails = styled.div`
background-color:#ECECEC;
position: relative;
border-radius: ${pxToRem(8)} : ${pxToRem(8)} ${pxToRem(8)} 0 0 ;
//box-shadow : 0 ${pxToRem(2)} ${pxToRem(8)} #00000029 : none;
//box-shadow : 0 ${pxToRem(2)} ${pxToRem(8)} #00000029 : 0;
margin-bottom:  ${pxToRem(16)};
height:${pxToRem(40)};
//margin-top:  ${pxToRem(20)};
${up('md')} {
  border-radius: ${pxToRem(8)} ${pxToRem(8)} 0 0 ;
  //box-shadow: 0 ${pxToRem(2)} ${pxToRem(8)} #00000029 ;
  margin-top:  ${pxToRem(24)} : 10px;
}
`;

const StyledNomineeMsg = styled.div`
  width: 70%;
  text-align: center;
  font-weight: 550;
  padding-bottom: 20px;
  ${up('md')} {
    width: 70%;
  }
`;

const StyledNomineeModal = styled(Modal)`
  min-height: 430px;
  padding: 0px;
  ${up('md')} {
    min-height: 330px;
    padding: 0px;
  }
`;

const StyledConfirmButton = styled(Button)`
  width: 100%;
  margin-top: ${pxToRem(16)};
  ${up('md')} {
    width: ${pxToRem(160)};
    margin-top: 0;
  }
`;

const Styled2FAModal = styled(Modal)`
  padding-top: 10px;
  padding-bottom: 0px;
`;

const AccordianErrorMessage = styled.div`
  font-style: italic;
  color: red;
  font-size: 0.75rem;
`;
